import { rankingData } from '@/mocks/homeData';

const trendIcons: Record<string, string> = {
  up: 'ri-arrow-up-line text-accent-500',
  hot: 'ri-fire-line text-primary-500',
  new: 'ri-sparkling-line text-accent-500',
};

const rankColors = ['text-primary-500', 'text-accent-500', 'text-accent-600', 'text-foreground-400', 'text-foreground-400'];

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full px-4 md:px-6 lg:px-12 py-12 md:py-16 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-8">热度榜单</h2>
        <div className="bg-background-100 rounded-xl border border-background-200/70 overflow-hidden">
          {rankingData.map((item, idx) => (
            <div
              key={item.rank}
              className={`flex items-center gap-4 p-4 ${
                idx < rankingData.length - 1 ? 'border-b border-background-200/50' : ''
              } transition-colors hover:bg-background-50 cursor-pointer`}
            >
              <span className={`text-lg font-bold w-8 text-center flex-shrink-0 ${rankColors[idx] || 'text-foreground-400'}`}>
                {item.rank}
              </span>
              <div className="flex-1 min-w-0">
                <span className="text-sm font-medium text-foreground-800 block whitespace-nowrap overflow-hidden text-ellipsis">{item.title}</span>
              </div>
              <span className="text-xs font-semibold text-foreground-600 whitespace-nowrap">{item.heat}</span>
              <span className="flex-shrink-0">
                <i className={`text-sm ${trendIcons[item.trend] || trendIcons.up}`}></i>
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}